// extracted by mini-css-extract-plugin
module.exports = {"summary":"OverviewFiltersSummary_summary__cX__d","nohits":"OverviewFiltersSummary_nohits__niSZF"};